export default __webpack_public_path__ + "static/fhqLuBul-a29612b4126daccc0cfd266c53a52f95.svg";